
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PageTitle',
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    descriptionWidthClass: {
      type: String,
      default: 'max-w-md'
    }
  }
})
